import { Text, Title3 } from "@fluentui/react-components";
import { INVALID_URL } from "apps/diagnostics/common/constants";
import { WarningIcon } from "../icons/WarningIcon";
import { PoweredByFooter } from "../PoweredByFooter/PoweredByFooter";
import { useStyles } from "./externalDiagnosticsInvalidUrl.styles";

export const ExternalDiagnosticsInvalidUrl = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.warningCircle}>
          <WarningIcon />
        </div>

        <Title3 className={styles.title}>Invalid URL</Title3>

        <Text role="alert" className={styles.messageContent}>
          {INVALID_URL}
        </Text>
      </div>
    </div>
  );
};
